module.exports = __webpack_public_path__ + "static/img/voyce.b5e8d73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/voyce.png
// module id = 48c2
// module chunks = 1